import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { Stack } from "types/generated";
import { AccessResult, hasAtLeastReadAccess, NO_ACCESS_MESSAGE } from "utils/access";

// FYI: the "stack.canWrite" check here is for legacy stacks (could be affected by access policies)
const useHasStackReadAccess = (): ((stack?: Stack) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (stack?: Stack) => {
      if (!stack) {
        return { result: false };
      }

      if (viewer.admin) {
        return { result: true };
      }

      if (stack.canWrite) {
        return { result: true };
      }

      const result = hasAtLeastReadAccess(viewer, stack.spaceDetails?.id || stack.space);

      if (result) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useHasStackReadAccess;
